import React from 'react';
// components
import Rooms from '../components/Rooms';
import HeroSlider from '../components/HeroSlider';

const Home = () => {
  return (
    <>
      <HeroSlider />
      
      <Rooms /> 
    </>
  );
};

export default Home;
